import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "container"]

  declare previewTarget: HTMLElement
  declare containerTarget: HTMLElement

  private menuScaleReady = false

  connect() {
    this.setupEventListeners()
    this.checkIfReady()
  }

  private setupEventListeners() {
    // menu-scale準備完了イベントをリッスン
    this.containerTarget.addEventListener('menu-scale:ready', () => {
      this.menuScaleReady = true
      this.checkIfReady()
    })
  }

  private checkIfReady() {
    if (this.menuScaleReady) {
      this.hideLoader()
    }
  }

  private hideLoader() {
    const loader = this.containerTarget.querySelector('.p-menu__loader') as HTMLElement | null
    if (loader) {
      loader.style.opacity = '0'
      loader.style.pointerEvents = 'none'
      // トランジション後に完全に非表示にする
      setTimeout(() => {
        loader.style.display = 'none'
      }, 300)
    }

    // プレビューを表示
    if (this.previewTarget) {
      this.previewTarget.style.opacity = '1'
    }
  }
}
